import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import CookieService from "../../context/cookies";

import { base } from "../../constants/apis";

export const emailManagementApi = createApi({
  reducerPath: "emailManagementApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${base}/apis/deal_tracker_email_management`,
    prepareHeaders: (headers) => {
      const token = CookieService.getCookie("jwtToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["emailManagement"],
  endpoints: (builder) => ({
    sendEmailNotify: builder.mutation({
      query: (payload) => ({
        url: "/add.php",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useSendEmailNotifyMutation } = emailManagementApi;
